import mainImage from '../../../assets/case-studies/case-study-cooler.webp';
import expertImage from '../../../assets/expert/expert-2.webp';

const post = {
  slug: 'handwerk',
  branch: 'Handwerk',
  industry: 'Klima- & Kältetechnik',
  title: 'Branchenlösung Klima- & Kältetechnik – Moderne WordPress-Webseite',
  excerpt:
    'Eine moderne, klar strukturierte WordPress-Webseite für ein Klima- und Kältetechnikunternehmen – mit übersichtlicher Leistungsdarstellung, smartphone-optimierter Bedienung und einem FAQ-Bereich, der unqualifizierte Anfragen filtert.',
  summary:
    'Für ein Klima- und Kältetechnikunternehmen haben wir eine moderne, klar strukturierte WordPress-Webseite umgesetzt. Im Fokus: übersichtliche Darstellung der Dienstleistungen, einfache und direkte Kontaktaufnahme, voll responsive Umsetzung für Smartphones und ein intelligenter FAQ-Bereich, der unnötige Anfragen reduziert und qualifizierte Leads stärkt.',
  author: 'Nexite Team',
  date: '2025-08-06',
  image: mainImage,
  website: 'https://construction.accura-it.com',
  contact: {
    name: 'Behrus Faga',
    title: 'Digitalberater',
    description:
      'Begleitet Handwerksbetriebe bei der digitalen Positionierung – von der modernen Website über strukturierte Anfragenprozesse bis hin zu Automatisierung und Kundenbindung.',
    image: expertImage,
  },
  sections: [
    {
      heading: 'Ausgangssituation: Gute Arbeit, aber wenig digitale Sichtbarkeit',
      paragraphs: [
        'Das Klima- und Kältetechnikunternehmen stand vor einer typischen Herausforderung: Die handwerkliche Qualität war hoch – doch die alte Online-Präsenz wirkte unübersichtlich, nicht mehr zeitgemäß und war auf dem Smartphone schwer nutzbar. Viele potenzielle Kund:innen sprangen ab, noch bevor sie eine Anfrage stellten.',
      ],
    },
    {
      heading: 'Solution: Moderne WordPress-Webseite als digitale Visitenkarte',
      paragraphs: [
        'Auf Basis von WordPress haben wir eine moderne, leicht pflegbare Webseite erstellt, die das Unternehmen professionell nach außen präsentiert. Das Design ist klar, aufgeräumt und orientiert sich an der Zielgruppe: Immobilieneigentümer:innen, Bauunternehmen und Privatkund:innen, die schnell verstehen wollen, welche Leistungen angeboten werden und wie sie Kontakt aufnehmen können.',
      ],
    },
    {
      heading: 'Übersichtlich strukturierte Dienstleistungen',
      paragraphs: [
        'Die verschiedenen Dienstleistungen – etwa Beratung, Planung, Installation und Wartung – wurden in logisch aufgebaute Bereiche gegliedert. Jede Leistungsseite bietet strukturierte Informationen mit klaren Nutzenargumenten, damit Kund:innen ohne Umwege die passende Lösung finden. Das reduziert Rückfragen und stärkt das professionelle Auftreten des Betriebs.',
      ],
    },
    {
      heading: 'Direkte Kontaktaufnahme ohne Hürden',
      paragraphs: [
        'Ein zentrales Ziel war es, die Kontaktaufnahme maximal einfach zu gestalten. Deshalb sind auf nahezu jeder Seite deutlich sichtbare Call-to-Action-Elemente integriert: Kontaktbuttons, klare Kontaktbereiche und ein schlankes Formular ohne unnötige Felder. So können Interessent:innen schnell und ohne Barrieren eine Anfrage stellen – egal ob vom Desktop oder Smartphone.',
      ],
    },
    {
      heading: 'Smartphone-optimiert für eine mobile Zielgruppe',
      paragraphs: [
        'Da ein Großteil der Nutzer:innen über das Smartphone nach Handwerksbetrieben sucht, wurde die Seite konsequent responsiv umgesetzt. Texte, Bilder, Buttons und Formulare sind für kleine Displays optimiert. Das sorgt dafür, dass die Website auch unterwegs professionell wirkt und einfach bedient werden kann – ein wichtiger Faktor für die Entscheidung der Kund:innen.',
      ],
    },
    {
      heading: 'FAQ-Bereich: Qualifizierte Anfragen statt Zeitfresser',
      paragraphs: [
        'Um das Büro zu entlasten, haben wir einen strukturierten FAQ-Bereich integriert. Häufige Fragen – etwa zu Abläufen, Kostenrahmen oder technischen Voraussetzungen – werden dort direkt beantwortet. Kund:innen können sich vorab informieren, wodurch viele Standardfragen bereits geklärt sind. So kommen über das Kontaktformular deutlich mehr vorqualifizierte und konkrete Anfragen an, während unnötige oder unpassende Anfragen automatisch ausgesiebt werden.',
      ],
    },
    {
      heading: 'Technische Basis: Flexibel erweiterbar mit WordPress',
      paragraphs: [
        'Dank WordPress als technischer Grundlage kann das Unternehmen Inhalte später selbstständig ergänzen oder anpassen – etwa neue Referenzprojekte, zusätzliche Leistungen oder aktualisierte FAQ-Einträge. Das System ist darauf ausgelegt, mit dem Betrieb mitzuwachsen, ohne dass dafür jedes Mal ein kompletter Relaunch notwendig ist.',
      ],
    },
    {
      heading: 'Ergebnisse und Wirkung',
      paragraphs: [
        'Die neue Website sorgt für ein deutlich moderneres Auftreten, bessere Auffindbarkeit und strukturiertere Kommunikation mit Kund:innen. Anfragen werden gezielter, die Kontaktaufnahme ist einfacher und die wichtigsten Informationen sind sofort sichtbar. So gewinnt der Betrieb nicht nur neue Kund:innen, sondern spart gleichzeitig Zeit im Tagesgeschäft – durch weniger Rückfragen und mehr relevante Kontakte.',
      ],
    },
  ],
  related: [],
};

export default post;
